export enum InstrumentPositionFilterTypes {
  Today = 'Today',
  Historical = 'Historical'
}
